import React from 'react';
import { DatePresetsModel, defaultDatePresetsModel } from '../../model/DatePresetsModel';


// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IDatePresetsContext {
    datePresets: DatePresetsModel;
    setDatePresets: (datePresets: DatePresetsModel) => void;
}

function emptyDatePresets(_inputs: DatePresetsModel) {
    return;
}
const initialStore: IDatePresetsContext  = {
    datePresets: defaultDatePresetsModel,
    setDatePresets: emptyDatePresets,
        }
export const DatePresetsContext = React.createContext<IDatePresetsContext>(initialStore);



